const initialState = {
    paymentMethod: null,
    isLoad: false,
    orderData: null,
    isLoadPaymentMethod: false,
    availablePaymentMethods: [],
};

export default initialState;
